import Cookies from 'js-cookie';

export const getFlagsFromCookies = (flagNames: Array<string> = []): FeatureFlag[] =>
    flagNames.map((flagName) => {
        return {
            name: flagName,
            isActive: Cookies.get(flagName)?.toLocaleLowerCase() == 'true',
        } as FeatureFlag;
    });

export const isFlagSet = (flagName: string): boolean => {
    const flags = getFlagsFromCookies([flagName]);
    if (flags.length > 0) {
        return flags[0].isActive;
    }

    return false;
};
